// Analytics Tracking Utility
// Lightweight event tracking for pricing interactions

// Track event function - can be connected to analytics provider later
export const trackEvent = (eventName, payload = {}) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics]', eventName, payload);
  }
  
  // Future: Send to analytics provider
  // Example: window.gtag?.('event', eventName, payload);
  // Example: window.analytics?.track(eventName, payload);
  
  // Store in session for debugging
  try {
    const events = JSON.parse(sessionStorage.getItem('analytics_events') || '[]');
    events.push({
      event: eventName,
      payload,
      timestamp: new Date().toISOString()
    });
    sessionStorage.setItem('analytics_events', JSON.stringify(events.slice(-50))); // Keep last 50
  } catch (e) {
    // Silently fail if sessionStorage is not available
  }
};

// Pricing-specific events
export const trackPricingToggle = (period) => {
  trackEvent('pricing_toggle_changed', { period });
};

export const trackPricingPrimaryCta = (planId, billingPeriod) => {
  trackEvent('pricing_primary_cta_clicked', { planId, billingPeriod });
};

export const trackPricingDetailsCta = (planId) => {
  trackEvent('pricing_details_clicked', { planId });
};

export const trackCheckoutStarted = (planId, billingPeriod, amount) => {
  trackEvent('checkout_started', { planId, billingPeriod, amount });
};

export const trackCheckoutCompleted = (planId, billingPeriod, amount) => {
  trackEvent('checkout_completed', { planId, billingPeriod, amount });
};
